<app-search-overlay *ngIf="config" [config]="config" [canEdit]="canEdit" (open)="onOpen()" (change)="onChange($event); change.emit($event)">
</app-search-overlay>

<ng-template #selectedTemplate>
  <app-badge *ngIf="config.selecteds.length > 0"
    [labels]="config.selecteds | getOverlayLabels"
    [cssClass]="'badge-group-opacity'"
    [displayLabels]="displayLabels"
    [suffixCssClass]="'badge-group-opacity'"
    [suffix]="true"></app-badge>
  <div class="text-muted f-italic" *ngIf="config.selecteds.length == 0" [title]="'Set Group' | translate"><app-i18n
      [key]="'No Group'"></app-i18n></div>
</ng-template>

<ng-template #optionTemplate let-item="item">
  <span class="badge badge-group-opacity badge-main badge-pill pre-checkbox">{{item.name}}</span>
</ng-template>
